import { createAction } from 'redux-actions';

import { AUTH, LOGOUT, UPDATE_USER_DATA } from './types';

export const signIn = createAction(AUTH);
export const logout = createAction(LOGOUT);
export const updateUserData = createAction(UPDATE_USER_DATA);
